import React from 'react';
import { connect } from 'react-redux';

import { ResponseRouteWrapper } from '../../../Shared/index';
import ResponsesManager from './responsesManager.jsx';

const ConnectResponseRouteWrapper = (props) => {
  return (
    <ResponseRouteWrapper
      {...props}
      additionalDatasets={['fillInBlank']}
      ResponsesManager={ResponsesManager}
    />
  );
};

function select(state) {
  return {
    questions: state.questions,
    fillInBlank: state.fillInBlank,
  };
}

export default connect(select)(ConnectResponseRouteWrapper);
